import { render, staticRenderFns } from "./CostPricing.vue?vue&type=template&id=87da2a8c&scoped=true"
import script from "./CostPricing.vue?vue&type=script&lang=js"
export * from "./CostPricing.vue?vue&type=script&lang=js"
import style0 from "./CostPricing.vue?vue&type=style&index=0&id=87da2a8c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87da2a8c",
  null
  
)

export default component.exports